import type { CompanyCommandData } from '@festina/legalentity-general-types/legalentity'
import type { ExcludeString } from '@festina-life/core'

import { CreateCompanyCommand } from '../../legalentityactions/CreateCompanyCommand'
import { UpdateCompanyNameCommand } from '../../legalentityactions/updateCompanyName/UpdateCompanyNameCommand'
import { LegalentityCommandModalButtonFallback } from '../LegalentityCommandModalButtonFallback'
import type { CommandDataRecord } from '../types'
import { sharedLegalentityCommands } from './sharedLegalentityCommands'

export const companyCommands: CommandDataRecord<
  ExcludeString<CompanyCommandData['_type']>
> &
  typeof sharedLegalentityCommands = {
  ...sharedLegalentityCommands,
  CreateCompanyCommandData: CreateCompanyCommand,
  UpdateCompanyCommandData: LegalentityCommandModalButtonFallback,
  InformationalCompanyExternalIdChangedCommandData:
    LegalentityCommandModalButtonFallback, // has a "create" with `<ExternalIdChangeDataCompanyCommand`
  UpdateCompanyNameCommandData: UpdateCompanyNameCommand,
}
